import React from "react";
import _ from "lodash";

const InputContainer = ({ user, signUp, onInputChange }) => {
  return (
    <div className="signin-input-container">
      {signUp && (
        <input
          name="name"
          type="text"
          value={user.name}
          className="input-div"
          placeholder="Name"
          onChange={(e) => onInputChange(e.target.value, e.target.name)}
        />
      )}
      <input
        name="email"
        type="email"
        value={user.email}
        className="input-div"
        placeholder="Email"
        onChange={(e) => onInputChange(e.target.value, e.target.name)}
      />
      <div>
        <input
          name="password"
          type="password"
          value={user.password}
          placeholder="Password"
          onChange={(e) => onInputChange(e.target.value, e.target.name)}
          className={`input-div ${signUp ? "" : "forgotpassword"} ${
            _.isEmpty(user.password) ? "" : "password"
          }`}
          style={{ marginBottom: "12px" }}
        />
      </div>
    </div>
  );
};

export default InputContainer;
